import { getCorrespondenceLanguagesBySu, getLanguageFallBackBySu } from '@/config/app.config';
import { WatchOptions } from 'vue';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class LanguagePicker extends Vue {
  private languages: string[] = [];
  private fallBack: string = '';
  private get suName() { return this.$route.params.screening; }

  /**
   * Au moment ou on sélectionne une autre langue, on la change également au
   * niveau de la variable locale du fichier i18n.ts qui gère les traductions
   * @date 17.08.2023 - 11:15:58
   *
   * @protected
   * @param {string} lang - La langue sélectionnée dans la gui
   */
  protected changeLocale(lang: string): void {
    this.$i18n.locale = lang;
  }

  /**
   * Cette méthode est lancé à chaque changement de l'url
   * Elle détermine quelle langue est sélectionné de manière visuelle mais aussi
   * au niveau de la variable locale du fichier i18n.ts pour la gestion des traductions
   * @date 17.08.2023 - 11:13:19
   *
   * @protected
   * @param {string} lang - Language selectionné dans l'interface
   * @returns {boolean} - Boolean qui va définir si une langue est sélectionnée ou non
   */
   protected isCurrentLanguage(lang: string): boolean {
    if (this.languages.includes(this.$i18n.locale)) {
      return this.$i18n.locale === lang;
    }
    return this.fallBack === lang;
    }

  /**
   * La route n'est pas forcément chargé en même temps que la page
   * c'est pour cela que l'on a besoin d'un watcher
   * @date 16.08.2023 - 15:03:56
   *
   * @protected
   * @param {string} suName -- nom du screening
   * @param {string} oldSuName --nom de l'ancien su (l'url change)
   */
  @Watch('suName', { immediate: true, deep: true } as WatchOptions)
  protected onLocaleChanged(suName: string, oldSuName: string) {
    if (oldSuName !== suName && suName !== undefined) {
      this.$i18n.locale = getLanguageFallBackBySu(this.$route.params.screening);
      this.languages = getCorrespondenceLanguagesBySu(this.$route.params.screening);
      this.fallBack = getLanguageFallBackBySu(this.$route.params.screening);
    }
  }
}
